import { createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";

import { reissuePassword as reissuePasswordAPI } from "../../sdk/apis";

export const infoSlice = createSlice({
  name: 'info',
  initialState: {
    success: false,
    message: '',
  },
  reducers: {
    setSuccess: (state) => {
      state.success = true;
      // state.message = '仮パスワードをメールで送付しました。ログイン後、パスワードの再登録をお願いします。';
      state.message = 'パスワード再発行処理を受け付けました。\n再発行メールが届かない場合、時間を空けて再度お試しください。Your password reissue request has been successfully accepted. If you do not receive the reissue email, please wait a while and try again.';
    },
    setFailed: (state, action) => {
      state.success = false;
      state.message = action.payload;
    }
  },
});

export const { setSuccess, setFailed } = infoSlice.actions;

export function reissuePassword(account_id: string, email: string) {
  return (dispatch: (f: any) => void, getState: () => any) => {
    const s = getState();
    reissuePasswordAPI(account_id, email).then((result) => {
      if (result.succeeded) {
        dispatch(setSuccess());
        dispatch(push('/reissue_password/'));
      }
      else {
        dispatch(setFailed(result.message));
      }
    })
  }
}


export default infoSlice.reducer;
